var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"scroll--y",class:[_vm.baseClass, { divided: _vm.isLayoutDivided }]},[_c('section',{class:`${_vm.baseClass}__left-content scroll--y`},[_vm._t("left-content")],2),(_vm.isLayoutDivided)?_c('section',{class:`${_vm.baseClass}__right-content scroll--y`},[_vm._t("right-content")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }